const IGN_GEOCODING_API_URL = "https://data.geopf.fr/geocodage/search";

export type AddressSuggestion = {
  id: string
  label: string
  street: string
  postcode: string
  city: string
};

type IGNFeature = {
  properties: {
    id: string
    label: string
    name: string
    postcode: string
    city: string
    type: string
  }
};

type IGNGeocodingResponse = { features: IGNFeature[] };

export const searchAddresses = async (
  query: string,
  limit: number = 5,
): Promise<AddressSuggestion[]> => {
  if (!query || query.length < 3) {
    return [];
  }

  try {
    const params = new URLSearchParams({
      q: query,
      limit: (limit * 2).toString(), // Récupérer plus de résultats pour le tri
    });

    const response = await fetch(`${IGN_GEOCODING_API_URL}?${params.toString()}`);

    if (!response.ok) {
      return [];
    }

    const data: IGNGeocodingResponse = await response.json();

    // Trier pour mettre les housenumber en premier
    const sortedFeatures = data.features.sort((a, b) => {
      const aIsHousenumber = a.properties.type === "housenumber" ? 0 : 1;
      const bIsHousenumber = b.properties.type === "housenumber" ? 0 : 1;
      return aIsHousenumber - bIsHousenumber;
    });

    return sortedFeatures.slice(0, limit).map((feature) => ({
      id: feature.properties.id,
      label: feature.properties.label,
      street: feature.properties.name,
      postcode: feature.properties.postcode,
      city: feature.properties.city,
    }));
  }
  catch {
    // En cas d'erreur (API down, réseau, etc.), retourner un tableau vide
    // pour permettre la saisie manuelle
    return [];
  }
};
